import { render, staticRenderFns } from "./androidXOnHoverFile_enUS.vue?vue&type=template&id=12564c69&scoped=true"
import script from "./androidXOnHoverFile_enUS.vue?vue&type=script&lang=js"
export * from "./androidXOnHoverFile_enUS.vue?vue&type=script&lang=js"
import style0 from "./androidXOnHoverFile_enUS.vue?vue&type=style&index=0&id=12564c69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12564c69",
  null
  
)

export default component.exports